/**
 * SF34 — Audio/Video to JSON Workflow
 * ऑडियो/वीडियो से JSON workflow — end-to-end use case
 */
const USE_CASES = Object.freeze([
    Object.freeze({
        useCaseId: 'uc-01',
        name: 'kundali_audio_to_json',
        description: 'मालिक ने कुंडली audio दिया। Assistant transcript बनाकर JSON निकालता है।',
        inputType: 'audio',
        domainHint: 'kundali',
        expectedPath: Object.freeze([
            'audio source validate',
            'consent',
            'budget check',
            'transcription dry-run/owner-approved staging',
            'transcript redaction',
            'transcript segments',
            'kundali JSON extraction',
            'preview',
            'owner approval',
            'write outputs',
            'audit',
        ]),
        ownerApprovalPoints: Object.freeze([
            'consent for processing',
            'transcription approval',
            'write approval',
        ]),
        auditPoints: Object.freeze([
            'intake audit',
            'transcription audit',
            'redaction audit',
            'extraction audit',
            'write audit',
        ]),
    }),
    Object.freeze({
        useCaseId: 'uc-02',
        name: 'vastu_video_to_json',
        description: 'मालिक ने वास्तु video दिया। Transcript से structured JSON।',
        inputType: 'video',
        domainHint: 'vastu',
        expectedPath: Object.freeze([
            'video source validate',
            'consent',
            'budget check',
            'transcription dry-run/owner-approved staging',
            'transcript redaction',
            'transcript segments',
            'vastu JSON extraction',
            'preview',
            'owner approval',
            'write outputs',
            'audit',
        ]),
        ownerApprovalPoints: Object.freeze([
            'consent for processing',
            'transcription approval',
            'write approval',
        ]),
        auditPoints: Object.freeze([
            'intake audit',
            'transcription audit',
            'redaction audit',
            'extraction audit',
            'write audit',
        ]),
    }),
    Object.freeze({
        useCaseId: 'uc-03',
        name: 'youtube_transcript_to_checklist',
        description: 'YouTube page से transcript/caption -> general checklist।',
        inputType: 'youtube-caption',
        domainHint: 'general',
        expectedPath: Object.freeze([
            'YouTube page read',
            'transcript/caption extract',
            'no video download',
            'no login action',
            'text extraction',
            'checklist generation',
            'preview',
            'owner approval',
            'write output',
            'audit',
        ]),
        ownerApprovalPoints: Object.freeze([
            'page read approval',
            'write approval',
        ]),
        auditPoints: Object.freeze([
            'page read audit',
            'extraction audit',
            'write audit',
        ]),
    }),
]);
export const AUDIO_VIDEO_TO_JSON_WORKFLOW_SF34 = Object.freeze({
    version: '0.1.103',
    useCases: USE_CASES,
    totalUseCases: USE_CASES.length,
    consentBeforeTranscription: true,
    budgetBeforeProviderCall: true,
    redactionBeforePersist: true,
    jsonExtractionAfterTranscript: true,
    safeWriteBeforeFileOutput: true,
    auditRequired: true,
    rollbackRequired: true,
});
//# sourceMappingURL=audioVideoToJsonWorkflowSf34.js.map